// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"styles_iconButton__1xquJ","menuPaper":"styles_menuPaper__3g1rb","menuList":"styles_menuList__vX_Jt","studentLink":"styles_studentLink__SixdU"};